import { createFileRoute } from '@tanstack/react-router'
import { CreateTaskRouteComponent } from '../../../../../../../../../../containers/tasks/create-task/create-task-route-component'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/'
)({
  component: CreateTaskRouteComponent
})
